import type { ExposeType } from "../../../utils/store-expose";
import {
  getReserveTime,
  getReserveTimeForTomorrow,
  getReserveTimeBefore30Minutes,
} from "../utils/pack-reserve-time";
import type { PackReserveTimeMap } from "../utils/pack-reserve-time";

interface PackPickupInfoProps {
  reserveTime: PackReserveTimeMap | null | undefined;
  exposeType: ExposeType;
}

const PackPickupInfo = ({ reserveTime, exposeType }: PackPickupInfoProps) => {
  const reserveTimeStr =
    exposeType === "오늘"
      ? getReserveTime(reserveTime)
      : exposeType === "내일"
        ? "내일 " + getReserveTimeForTomorrow(reserveTime)
        : "-";

  const confirmTimeStr =
    exposeType === "오늘"
      ? getReserveTimeBefore30Minutes(reserveTime, false)
      : exposeType === "내일"
        ? "내일 " + getReserveTimeBefore30Minutes(reserveTime, true)
        : "-";

  return (
    <div className="grid grid-cols-[1fr_auto_1fr] items-center bg-[#F8F9FA] rounded-xl py-4 mx-1 mb-3">
      <div className="flex flex-col justify-start items-start pl-5 pr-2 gap-y-0.5">
        <span className="text-gray-500 text-[11px] sm:text-xs font-medium whitespace-nowrap">
          픽업 시간
        </span>
        <span className="text-gray-800 font-bold text-[12px] sm:text-sm leading-tight">
          {reserveTimeStr}
        </span>
      </div>
      <div className="w-[1px] h-8 bg-gray-300"></div>
      <div className="flex flex-col justify-start items-start pl-4 pr-2 gap-y-0.5">
        <span className="text-gray-500 text-[11px] sm:text-xs font-medium whitespace-nowrap">
          확정 시간
        </span>
        <span className="text-gray-800 font-bold text-[12px] sm:text-sm leading-tight">
          {confirmTimeStr}
        </span>
      </div>
    </div>
  );
};

export default PackPickupInfo;
